export const driverCapsTemplate = {
    cameras: {},
    cameraPresets: {},
    disabledCalls: {
        googleMeet: 0,
        pstn: 0,
        teams: 0,
        video: 0,
        voip: 0,
        zoom: 0,
    },
    hasBusy: false,
    hasCalendar: false,
    hasDirectory: false,
    hasDisplayBlank: false,
    hasDisplayBlankUi: false,
    hasDisplayFreeze: false,
    hasDisplayFreezeUi: false,
    hasFirmwareVersion: false,
    hasPowerControl: false,
    hasRoomMute: false,
    hasRoomVolume: false,
    hasRoomVolumeMute: false,
    hasSerialNumber: false,
    hasVolume: false,
    hasVolumeMute: false,
    hasVideoInputs: false,
    hasVideoOutputs: false,
    hasVideoSwitcher: false,
    hasZoomConnector: false,
    isDisplayBlankStateless: false,
    isDisplayFreezeStateless: false,
    isPowerStateless: false,
    isPowerToggle: false,
    isRoomVolumeIncDec: false,
    isRoomVolumeStateless: false,
    isVideoInputStateless: false,
    isVolumeIncDec: false,
    isVolumeStateless: false,
    lightingControls: {},
    lightingPresets: {},
    maxCalls: {
        googleMeet: 0,
        pstn: 0,
        teams: 0,
        video: 0,
        voip: 0,
        zoom: 0,
    },
    videoInputs: {},
    videoInputsAreContent: false,
};
export function isVideoInputInternal(videoInput) {
    return (videoInput.icon !== undefined &&
        videoInput.name !== undefined);
}
export function hasMediaPlayerCaps(caps) {
    return caps.some(op => [
        'mediaPlayerForward',
        'mediaPlayerNext',
        'mediaPlayerPause',
        'mediaPlayerPrevious',
        'mediaPlayerRecord',
        'mediaPlayerRecordToggle',
        'mediaPlayerReverse',
        'mediaPlayerPlay',
        'mediaPlayerSkipAhead',
        'mediaPlayerSkipBack',
        'mediaPlayerStop',
    ].includes(op));
}
export function hasMediaRecorderCaps(caps) {
    return caps.some(op => ['mediaRecorderPause', 'mediaRecorderRecord', 'mediaRecorderRecordToggle'].includes(op));
}
export function hasMediaStreamerCaps(caps) {
    return caps.some(op => [
        'mediaStreamerForward',
        'mediaStreamerNext',
        'mediaStreamerPause',
        'mediaStreamerPrevious',
        'mediaStreamerRecord',
        'mediaStreamerRecordToggle',
        'mediaStreamerReverse',
        'mediaStreamerSkipAhead',
        'mediaStreamerSkipBack',
        'mediaStreamerStop',
        'mediaStreamerStream',
    ].includes(op));
}
